import React, { Component } from 'react'
import HomeListing from './../Listing/HomeListing';
import HomeSearch from './../Search/HomeSearch';
import Banner from './../Common/Banner';
// import BlogListing from '../Listing/BlogListing';
// import FooterContact from './../Form/FooterContact';

export default class Home extends Component {  
  render() {
    const {lang, history} = this.props;

    //Always start at top
    window.scrollTo(0 ,0);

    return (
        <React.Fragment>
            <HomeSearch lang={lang} history={history} />

            <Banner 
              /* Change What is necessary to change the banner also include the images in the public folder. */
              lang={lang}
              link={"https://www.acadienouvelle.com/concours/decouvreznb-2026/"}
              startdate={"2026-06-01"}
              enddate={"2026-08-31"}
              imgLargeFr={"/img/decouvreznb_concours_728x90.jpg"}
              imgMediumFr={"/img/decouvreznb_concours_600x400.jpg"}
              imgSmallFr={"/img/decouvreznb_concours_300x250.jpg"}
              imgLargeEn={"/img/decouvreznb_concours_728x90_ang.jpg"}
              imgMediumEn={"/img/decouvreznb_concours_600x400_ang.jpg"}
              imgSmallEn={"/img/decouvreznb_concours_300x250_ang.jpg"}
            />

            {/* <BlogListing lang={lang} perPage={3}/> */}

            <HomeListing lang={lang} />

            {/* <FooterContact lang={lang} /> */}
        </React.Fragment>
    )
  }
}